/**
 * 用于各类标签打印（'zebra', 'postek', 'sato'）
 */
import { pgMessage } from '../../message/index'
import { printTemplateCompile } from './print-template-compile'
import { sendPrint } from './jmreport'

export async function labelPrinter({ compileDatas, printTemplate }) {
  const { printTemplateContents } = await printTemplateCompile({
    printTemplate,
    compileDatas,
    html: false,
  })
  if (!printTemplateContents?.length) {
    pgMessage.error(`因数量为零的数据已过滤,目前无打印数据~`)
    return Promise.reject()
  }

  return sendPrint({
    compileDatas: printTemplateContents,
    printTemplate,
    url: '/api/label/print',
    getParam: (content) => {
      return {
        Brand: printTemplate.server?.code,
        Body:
          typeof content.content === 'object' ? JSON.stringify(content.content) : content.content,
      }
    },
  })
}
